import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchKargoFirmalari } from '../services/kargoFirmasiService';
import './KargoFirmasiField.css';

/**
 * Kargo firması seçimi: listeden select veya "Diğer" ile manuel giriş.
 */
export default function KargoFirmasiField({
  value = '',
  onChange,
  disabled = false,
  required = false,
  idPrefix = 'kargo-firmasi',
  label = 'Kargo Firması',
  optionalLabel = false,
}) {
  const [firmalar, setFirmalar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [diger, setDiger] = useState(false);

  const firmaAdlari = useMemo(() => firmalar.map((f) => f.ad).filter(Boolean), [firmalar]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetchKargoFirmalari();
      const arr = r?.veri?.kargoFirmalari || [];
      setFirmalar(Array.isArray(arr) ? arr : []);
    } catch {
      setFirmalar([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!value) {
      setDiger(false);
      return;
    }
    if (firmaAdlari.length > 0 && !firmaAdlari.includes(value)) {
      setDiger(true);
    }
  }, [value, firmaAdlari]);

  const selectId = `${idPrefix}-select`;
  const inputId = `${idPrefix}-manual`;
  const digerId = `${idPrefix}-diger`;

  const handleSelectChange = (e) => {
    onChange?.(e.target.value);
  };

  const handleManualChange = (e) => {
    onChange?.(e.target.value);
  };

  const handleDigerToggle = (e) => {
    const checked = e.target.checked;
    setDiger(checked);
    onChange?.('');
  };

  const labelText = optionalLabel ? `${label} (opsiyonel)` : label;

  return (
    <div className="kargo-firmasi-field">
      <label className="kargo-firmasi-field__label" htmlFor={diger ? inputId : selectId}>
        {labelText}
      </label>
      <div className="kargo-firmasi-field__row">
        <select
          id={selectId}
          className="kargo-firmasi-field__select"
          value={diger ? '' : value}
          onChange={handleSelectChange}
          disabled={disabled || diger || loading}
        >
          <option value="">{loading ? 'Yükleniyor…' : 'Firma seçin'}</option>
          {firmaAdlari.map((ad) => (
            <option key={ad} value={ad}>
              {ad}
            </option>
          ))}
        </select>
        <label className="kargo-firmasi-field__diger" htmlFor={digerId}>
          <input
            id={digerId}
            type="checkbox"
            checked={diger}
            onChange={handleDigerToggle}
            disabled={disabled}
          />
          <span>Diğer</span>
        </label>
      </div>
      {diger && (
        <input
          id={inputId}
          type="text"
          className="kargo-firmasi-field__manual"
          value={value}
          onChange={handleManualChange}
          placeholder="Kargo firması adı"
          maxLength={100}
          disabled={disabled}
          autoComplete="off"
          required={required}
        />
      )}
    </div>
  );
}
